import script from "./piechart.vue?vue&type=script&setup=true&lang=js"
export * from "./piechart.vue?vue&type=script&setup=true&lang=js"

import "./piechart.vue?vue&type=style&index=0&id=40313a21&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_59e517ed8ea5909a7bfb8c19836a23be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40313a21"]])

export default __exports__